<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
  [style]="{ width: '400px' }"
  [breakpoints]="{ '400px': '100vw' }"
  [header]="'columns.header' | translate"
  (onHide)="onHide()"
>
  <p-table
    responsiveLayout="scroll"
    styleClass="p-datatable-sm"
    [value]="columnOptions()"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'columns.visibility' | translate }}</th>
        <th>{{ 'columns.decimals' | translate }}</th>
        <th>{{ 'columns.fractions' | translate }}</th>
        <th>{{ 'columns.example' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-column>
      <tr>
        <td>
          <p-checkbox
            [(ngModel)]="editValue[column.value].show"
            [binary]="true"
            [label]="column.label | translate"
            [disabled]="column.disabled"
          ></p-checkbox>
        </td>
        @if ($any(columnsInf)[column.value].hasPrecision) {
          <td>
            <p-inputNumber
              [min]="0"
              [size]="1"
              [showButtons]="true"
              class="w-100"
              styleClass="w-100"
              inputStyleClass="text-end"
              [disabled]="!editValue[column.value].show"
              [(ngModel)]="editValue[column.value].precision"
            ></p-inputNumber>
          </td>
          <td class="text-center">
            <p-checkbox
              [ngModel]="editValue[column.value].precision == null"
              [binary]="true"
              [disabled]="!editValue[column.value].show"
              (onChange)="changeFraction($event.checked, column.value)"
            ></p-checkbox>
          </td>
          <td>
            {{ editValue[column.value].precision | precisionExample }}
          </td>
        } @else {
          <td colspan="3" class="text-center">
            <div class="p-2">{{ 'columns.notApplicable' | translate }}</div>
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    @if (modified) {
      <button
        pButton
        pRipple
        type="button"
        class="p-button-outlined"
        icon="fa-solid fa-rotate-left"
        [label]="'reset' | translate"
        (click)="reset()"
      ></button>
    }
    <button
      pButton
      pRipple
      type="button"
      class="p-button-outlined"
      icon="fa-solid fa-check"
      [label]="'ok' | translate"
      (click)="hide()"
    ></button>
    <button
      pButton
      pRipple
      type="button"
      class="p-button-outlined p-button-secondary"
      icon="fa-solid fa-xmark"
      [label]="'cancel' | translate"
      (click)="hide(true)"
    ></button>
  </ng-template>
</p-dialog>
